/* eslint-disable max-len */
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import subscriptionFields from '../../../fields/subscriptionFields';
import getIccidWithoutPrefix from '@/common-utils/functions/getIccidWithoutPrefix';
import PosTerminalLocation from '@/app/modules/terminals/components/location/PosTerminalLocation';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import SubscriptionBadge from '../../badge/SubscriptionBadge';
import RenderDateWithFromTimeAndColor from '@/common-utils/components/renders/date/RenderDateWithFromTimeAndColor';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RenderSubscriptionDirectProvider from '../../directProvider/RenderSubscriptionDirectProvider';
import RenderPosTerminalConnectionType from '@/app/modules/terminals/components/renders/connectionType/RenderPosTerminalConnectionType';
import { Badge } from '@/common-utils/components/ui/badge';
import POS_TERMINAL_STATUS from '@/app/modules/terminals/enums/PosTerminalStatus';
import RenderDateToRelativeText from '@/common-utils/components/renders/date/RenderDateToRelativeText';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import DropdownSubscriptionsActionsRow from '../../dropdown/DropdownSubscriptionsActionsRow';
import RouteUrls from '@/app/root/enums/RouteUrls';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import POS_TERMINALS_TABS from '@/app/root/enums/tabs/PosTerminalsTabs';
import SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS from '@/app/root/enums/tabs/SubscriptionAndTerminalDetailsTabs';
import payluddLogo from 'url:../../../../../../../resource/images/Logo_Payludd_N&B.png';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
import TRANSACTION_ORIGIN_APPLICATION from '@/app/modules/terminals/enums/OriginApplication';
import Permissions from '@/app/permissions/Permissions';

export const columnsSubscriptionId = 'subscription';
export const columnsSubscription = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsSubscriptionId, false, headerPackage.maxPicks),
        // Columns
        generateColumnDefByField({
            field: subscriptionFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ subscriptionId: row.original.uuid }}
                    baseUrl={RouteUrls.SUBSCRIPTION_DETAILS.url}
                    urlParams={{
                        view: POS_TERMINALS_TABS.SUBSCRIPTIONS.name,
                        viewDetails: SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS.DETAILS.name
                    }}
                    requiredPermissions={[Permissions.SUBSCRIPTION_READ.name]}
                />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: subscriptionFields.LAST_GEOLOCALISATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const connectionType = getObjectAttributeFromStringKey(
                    cell.row.original,
                    generateNestedFieldAccessor(subscriptionFields.LAST_CONNECTION_TYPE));
                const sourceIp = getObjectAttributeFromStringKey(
                    cell.row.original,
                    generateNestedFieldAccessor(subscriptionFields.LAST_SOURCE_IP));
                const posTerminalUuid = getObjectAttributeFromStringKey(
                    cell.row.original,
                    generateNestedFieldAccessor(subscriptionFields.POS_TERMINAL.UUID));
                return (
                    cell &&
                    <PosTerminalLocation
                        connectionType={connectionType}
                        sourceAddressIp={sourceIp}
                        posTerminalUuid={posTerminalUuid}
                    />
                );
            },
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: subscriptionFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                row &&
                <DropdownSubscriptionsActionsRow subscription={row.original} setLaunchRefetch={headerPackage.setLaunchRefetch} />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: subscriptionFields.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const isBroadcast = getObjectAttributeFromStringKey(
                    cell?.row?.original,
                    generateNestedFieldAccessor(subscriptionFields.POS_TERMINAL.IS_BROADCAST)
                );
                return (
                    cell &&
                    <div className='inline-flex flex-col items-center'>
                        <SubscriptionBadge cellValue={cell.getValue(subscriptionFields.STATUS.key)} row={cell.row} />
                        {isBroadcast === true &&
                            <TooltipHelper
                                trigger={
                                    <img
                                        src={payluddLogo}
                                        alt={TRANSACTION_ORIGIN_APPLICATION.BROADCAST.title}
                                        className='mt-1 h-5 w-5 object-contain'
                                    />
                                }
                                content={TRANSACTION_ORIGIN_APPLICATION.BROADCAST.title}
                            />
                        }
                    </div>
                );
            }
        }),
        generateColumnDefByField({
            field: subscriptionFields.LAST_CONNECTION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell && cell.getValue(subscriptionFields.LAST_CONNECTION_DATE.key) &&
                <RenderDateWithFromTimeAndColor
                    value={cell.getValue(subscriptionFields.LAST_CONNECTION_DATE.key)}
                    namespace={subscriptionFields.LAST_CONNECTION_DATE.namespace}
                />
            )
        }),
        generateColumnDefByField({
            field: subscriptionFields.LAST_CONNECTION_TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const simCardNumber = getObjectAttributeFromStringKey(cell.row.original,
                    subscriptionFields.LAST_ICCID.key);
                const iccidOperators = getObjectAttributeFromStringKey(cell.row.original,
                    subscriptionFields.LAST_ICCID_OPERATOR.key);
                return (
                    cell &&
                    <RenderPosTerminalConnectionType
                        connectionType={cell.getValue(subscriptionFields.LAST_CONNECTION_TYPE.key)}
                        iccidOperators={iccidOperators}
                        simNumber={simCardNumber}
                        iconOnly
                    />
                );
            }
        }),
        generateColumnDefByField({
            field: subscriptionFields.ACTIVE_ICCID,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <small>{getIccidWithoutPrefix(cell.getValue(subscriptionFields.ACTIVE_ICCID.key))}</small>
            )
        }),
        generateColumnDefByField({
            field: subscriptionFields.LAST_SOURCE_IP,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <small>{cell.getValue(subscriptionFields.LAST_SOURCE_IP.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: subscriptionFields.POS_TERMINAL.DIRECT_PROVIDER.PROVIDER_LEGAL_NAME,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const directProviderUuid = getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(subscriptionFields.POS_TERMINAL.DIRECT_PROVIDER.PROVIDER_UUID));
                return (
                    cell &&
                    <RenderSubscriptionDirectProvider directProviderLegalName={cell.getValue(subscriptionFields.POS_TERMINAL.DIRECT_PROVIDER.PROVIDER_LEGAL_NAME.key)} directProviderUuid={directProviderUuid} />
                );
            }
        }),
        generateColumnDefByField({
            field: subscriptionFields.CLIENT.LEGAL_NAME,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: subscriptionFields.CLIENT.CLIENT_CODE,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: subscriptionFields.POS_TERMINAL.SERIAL_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: subscriptionFields.POS_TERMINAL.MANUFACTURER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: subscriptionFields.POS_TERMINAL.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: subscriptionFields.POS_TERMINAL.CUSTOM_LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: subscriptionFields.POS_TERMINAL.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const status = POS_TERMINAL_STATUS[cell.getValue(subscriptionFields.POS_TERMINAL.STATUS)];
                const isPosTerminalTemporaryAllowed = status.name === POS_TERMINAL_STATUS.TEMPORARILY_ALLOWED.name;
                const unblacklist = getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(subscriptionFields.POS_TERMINAL.BLACKLIST_START_DATE));
                return (
                    cell &&
                    <div className='text-center'>
                        <div>
                            <Badge entity={status.entity} namespace={status.namespace} variant={status.variant} />
                        </div>
                        {
                            isPosTerminalTemporaryAllowed &&
                            <RenderDateToRelativeText value={unblacklist} />
                        }
                    </div>
                );
            }
        }),
        generateColumnDefByField({
            field: subscriptionFields.SUBSCRIPTION_PLAN.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: subscriptionFields.SUBSCRIPTION_PLAN.PRODUCT_CODE,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: subscriptionFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(subscriptionFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: subscriptionFields.ACTIVATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(subscriptionFields.ACTIVATION_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: subscriptionFields.POS_TERMINAL.REWAREHOUSE_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(subscriptionFields.POS_TERMINAL.REWAREHOUSE_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: subscriptionFields.RESILIATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(subscriptionFields.RESILIATION_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: subscriptionFields.START_BILLING_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(subscriptionFields.START_BILLING_DATE.key)} />
            )
        })
    ]).filter(col => !!col);
};